import {Controller} from "@/controllers/Controller";

/**
 * Controller for group API
 */
export class ProductionController extends Controller {

     static getAll(urlParams) {
         return this.requestBuilder("GET",`/production/orders/table/all${urlParams}`, true);
     }

     static get(id) {
         return this.requestBuilder("GET",`/production/orders/${id}`, true);
     }

     static delete(id) {
         return this.requestBuilder("DELETE",`/production/orders/${id}`, true);
     }

     static getNumbers() {
         return this.requestBuilder("GET",`/production/orders/numbers/all`, true);
     }

     static post(body) {
         return this.requestBuilder("POST",`/production/orders`, true, body);
     }

     static patch(id, body) {
         return this.requestBuilder("PATCH",`/production/orders/${id}`, true, body);
     }
}
